module.exports = __webpack_public_path__ + "static/media/veneto-3-15.46433c38.jpg";